import { Box } from "@stenajs-webui/core";
import { FlatButton, stenaInfoCircle } from "@stenajs-webui/elements";
import { Popover } from "@stenajs-webui/tooltip";
import { formatDateStringWithLocalTimeZone } from "@/lib/dates/formatters";
import { HeadAgreementBox } from "../../types";
import { InfoBoxItem } from "../../InfoBoxItem";
import { IndentValues } from "@/lib/utils/IndentValues";
import { SpaceValues } from "@/lib/utils/SpaceValues";
import { ZIndex } from "@/lib/utils/ZIndexEnum";

interface Props {
  headAgreement: HeadAgreementBox;
}

export const HeadAgreementInfoPairPopover: React.FC<Props> = ({
  headAgreement,
}) => {
  return (
    <>
      <Popover
        zIndex={ZIndex.high}
        placement={"right"}
        disablePadding
        appendTo={document.body}
        trigger={"click"}
        renderTrigger={(props) => (
          <Box width={16}>
            <FlatButton leftIcon={stenaInfoCircle} {...props} />
          </Box>
        )}
      >
        <Box indent={IndentValues.SIXTEEN} spacing={SpaceValues.EIGHT}>
          <InfoBoxItem
            leftContent={"Created"}
            rightContent={
              formatDateStringWithLocalTimeZone({
                dateString: headAgreement.writeHistory?.createdAt?.isoString,
                options: {
                  dateStyle: "short",
                  timeStyle: "short",
                },
              }) ?? ""
            }
            popoverEnabled
          />
          <InfoBoxItem
            leftContent={"Created by"}
            rightContent={headAgreement.writeHistory?.createdBy.name}
            popoverEnabled
          />
          <InfoBoxItem
            leftContent={"Modified"}
            rightContent={
              (headAgreement.writeHistory?.modifiedAt?.isoString &&
                formatDateStringWithLocalTimeZone({
                  dateString: headAgreement.writeHistory?.modifiedAt?.isoString,
                  options: {
                    dateStyle: "short",
                    timeStyle: "short",
                  },
                })) ??
              ""
            }
            popoverEnabled
          />
          <InfoBoxItem
            leftContent={"Modified by"}
            rightContent={headAgreement.writeHistory?.modifiedBy?.name ?? ""}
            popoverEnabled
          />
        </Box>
      </Popover>
    </>
  );
};
